module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theme),
      expression: "theme"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.theme = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "base"
    }
  }, [_vm._v("Base")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "blood-orange"
    }
  }, [_vm._v("Blood Orange")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dark-lime"
    }
  }, [_vm._v("Dark Lime")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "royal"
    }
  }, [_vm._v("Royal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "base--rounded"
    }
  }, [_vm._v("Base Round")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "blood-orange--rounded"
    }
  }, [_vm._v("Blood Orange Round")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dark-lime--rounded"
    }
  }, [_vm._v("Dark Lime Round")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "royal--rounded"
    }
  }, [_vm._v("Royal Round")])]), _vm._v(" "), _c('cookie-law', {
    attrs: {
      "theme": _vm.theme
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-96509596"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 14
// module chunks = 1